/* eslint-disable no-unused-vars */
import { Menu } from 'antd';
import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as DokanLogo } from '../../assets/images/dokan.svg';
import menuItems from '../../Routes';
import DokanIcons from '../icon/DokanIcons';
import DokanMenuIcons from '../icon/DokanMenuIcons';

function Sidebar({ isOpen, setIsOpen }) {
    const location = useLocation();
    // const [isActive, setIsActive] = useState(false);
    const activeClass = 'bg-gray-dark border-gray-dark';
    const inactiveClass = 'border-gray-dark ';

    return (
        <>
            <div
                className={`bg-gray-darkest ${
                    isOpen
                        ? 'min-h-screen hidden md:block md:col-span-2 md:sticky md:top-0 md:self-start'
                        : 'hidden'
                }`}
            >
                <div className="py-15px mr-20px ml-30px">
                    {/** sidebar top */}

                    <div className="flex items-center justify-between">
                        <Link to="/" className={`${isOpen ? 'block' : 'hidden'}`}>
                            <div className="flex items-center ml-15px">
                                <DokanLogo width="32" height="32" />
                                <h1 className="text-white text-md mx-2 ml-3 font-medium">Dokan</h1>
                            </div>
                        </Link>
                        {isOpen && (
                            <button
                                className="cursor-pointer p-1 focus:outline-none"
                                onClick={() => setIsOpen(false)}
                                type="button"
                            >
                                <DokanIcons icon="#open" size={4} />
                            </button>
                        )}
                    </div>
                    {/** end sidebar top */}
                    {/** sidebar items */}
                    <Menu theme="dark" mode="inline" selectable={false} className="pt-20px">
                        {menuItems.map(
                            (item) =>
                                item.sidebar && (
                                    <Menu.Item
                                        key={item.id}
                                        icon={<DokanMenuIcons icon={item.icon} size={4} />}
                                        className={`text-white flex items-center ${
                                            location.pathname === item.path
                                                ? activeClass
                                                : inactiveClass
                                        }`}
                                    >
                                        <NavLink
                                            exact={item.path === '/'}
                                            strict
                                            className="ml-12px"
                                            to={item.path}
                                            activeStyle={{ color: 'white' }}
                                        >
                                            {item.name}
                                        </NavLink>
                                    </Menu.Item>
                                )
                        )}
                    </Menu>
                </div>
            </div>
        </>
    );
}

export default Sidebar;
